import { lazy } from 'react';

export const StyleFormPageLazy = lazy(() => import('./StyleFormPage'));
